import React from "react";
import clsx from "clsx";
import { AlertTriangle, Lock, X } from "lucide-react";

/**
 * Persistent banner strip rendered above the schedule grid when one or more
 * blocks have drifted past 45 minutes (or any drift on a locked block per
 * PRD §9.5). Each banner is independently dismissible — but if drift continues
 * to grow, the watcher re-surfaces it.
 */
export default function DriftBanner({ banners, onDismiss, onOpenTask }) {
  if (!banners || banners.length === 0) return null;
  return (
    <div className="flex flex-col gap-px bg-bg-base" data-testid="drift-banner-stack">
      {banners.map((b) => (
        <div
          key={b.block_id}
          className={clsx(
            "flex items-center gap-3 px-4 py-1.5 border-b animate-slide-up",
            b.kind === "locked-knock-on"
              ? "bg-red-glow border-red text-red"
              : "bg-amber-glow border-amber text-amber"
          )}
          data-testid={`drift-banner-${b.block_id}`}
        >
          {b.kind === "locked-knock-on" ? (
            <Lock className="w-3.5 h-3.5 shrink-0" />
          ) : (
            <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
          )}
          <div className="mono text-2xs uppercase tracking-[0.2em] shrink-0">
            {b.kind === "locked-knock-on" ? "LOCKED · KNOCK-ON" : "DRIFT"}
          </div>
          <span className="mono text-sm tabular-nums font-semibold shrink-0">
            +{b.drift_min}m
          </span>
          <button
            type="button"
            onClick={() => onOpenTask && onOpenTask(b.block_id)}
            className="text-xs truncate text-left hover:underline flex-1 min-w-0 text-ink"
            data-testid={`drift-banner-open-${b.block_id}`}
            title={b.task_title}
          >
            {b.task_title}
          </button>
          <button
            type="button"
            onClick={() => onDismiss(b.block_id)}
            className="btn-ghost shrink-0"
            data-testid={`drift-banner-dismiss-${b.block_id}`}
            title="Dismiss (re-surfaces if drift grows)"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
